/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DriverLookupResultEnum } from '../models/driver-lookup-result-enum';
import { DriverModel } from '../models/driver-model';
import { InviteDriverCommand } from '../models/invite-driver-command';

@Injectable({
  providedIn: 'root',
})
export class DriversService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation getActive
   */
  static readonly GetActivePath = '/api/drivers/active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActive$Response(params?: { context?: HttpContext }): Observable<StrictHttpResponse<Array<DriverModel>>> {
    const rb = new RequestBuilder(this.rootUrl, DriversService.GetActivePath, 'get');
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<DriverModel>>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActive(params?: { context?: HttpContext }): Observable<Array<DriverModel>> {
    return this.getActive$Response(params).pipe(map((r: StrictHttpResponse<Array<DriverModel>>) => r.body as Array<DriverModel>));
  }

  /**
   * Path part for operation getInvited
   */
  static readonly GetInvitedPath = '/api/drivers/invited';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvited()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvited$Response(params?: { context?: HttpContext }): Observable<StrictHttpResponse<Array<DriverModel>>> {
    const rb = new RequestBuilder(this.rootUrl, DriversService.GetInvitedPath, 'get');
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<DriverModel>>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInvited$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvited(params?: { context?: HttpContext }): Observable<Array<DriverModel>> {
    return this.getInvited$Response(params).pipe(map((r: StrictHttpResponse<Array<DriverModel>>) => r.body as Array<DriverModel>));
  }

  /**
   * Path part for operation inviteDriver
   */
  static readonly InviteDriverPath = '/api/drivers/invite';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inviteDriver()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  inviteDriver$Response(params?: { context?: HttpContext; body?: InviteDriverCommand }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, DriversService.InviteDriverPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `inviteDriver$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  inviteDriver(params?: { context?: HttpContext; body?: InviteDriverCommand }): Observable<void> {
    return this.inviteDriver$Response(params).pipe(map((r: StrictHttpResponse<void>) => r.body as void));
  }

  /**
   * Path part for operation driverLookup
   */
  static readonly DriverLookupPath = '/api/drivers/lookup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `driverLookup()` instead.
   *
   * This method doesn't expect any request body.
   */
  driverLookup$Response(params?: {
    email?: string;
    carrierId?: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<DriverLookupResultEnum>> {
    const rb = new RequestBuilder(this.rootUrl, DriversService.DriverLookupPath, 'get');
    if (params) {
      rb.query('email', params.email, { style: 'form' });
      rb.query('carrierId', params.carrierId, { style: 'form' });
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<DriverLookupResultEnum>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `driverLookup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  driverLookup(params?: { email?: string; carrierId?: number; context?: HttpContext }): Observable<DriverLookupResultEnum> {
    return this.driverLookup$Response(params).pipe(
      map((r: StrictHttpResponse<DriverLookupResultEnum>) => r.body as DriverLookupResultEnum),
    );
  }
}
